import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Tooltip as Tippy } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

class Tooltip extends PureComponent {
  render() {
    const { children, text } = this.props; 

    return (
      <Tippy
        animation="perspective"
        arrow
        title={text}
        position="top"
        className="Tooltip"
      >
        {children}
      </Tippy>
    );
  }
}

Tooltip.propTypes = {
  /**
   * Content which should have tooltip
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,

  /**
   * Tooltip text
   */
  text: PropTypes.string.isRequired,
}

export default Tooltip;